import { render } from "./CleanRoom.vue?vue&type=template&id=3bc504ba"
import script from "./CleanRoom.vue?vue&type=script&lang=js"
export * from "./CleanRoom.vue?vue&type=script&lang=js"
script.render = render

export default script